import { Flame, Leaf, Star } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { allergenName } from "@/lib/format";

export function PopularBadge({ className = "" }) {
  const { t } = useLang();
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full bg-amber-500/90 px-2.5 py-1 text-xs font-bold text-white shadow-sm ${className}`}
      data-testid="badge-popular"
    >
      <Star className="h-3 w-3 fill-white" /> {t("popular")}
    </span>
  );
}

export function SpicyBadge() {
  const { t } = useLang();
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full bg-red-500/10 px-2 py-0.5 text-xs font-semibold text-red-600 dark:text-red-400"
      data-testid="badge-spicy"
    >
      <Flame className="h-3 w-3" /> {t("spicy")}
    </span>
  );
}

export function VegBadge() {
  const { t } = useLang();
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full bg-green-500/10 px-2 py-0.5 text-xs font-semibold text-green-600 dark:text-green-400"
      data-testid="badge-veg"
    >
      <Leaf className="h-3 w-3" /> {t("vegetarian")}
    </span>
  );
}

export function AllergenPills({ allergens = [] }) {
  const { lang } = useLang();
  if (!allergens.length) return null;
  return (
    <div className="flex flex-wrap gap-1.5" data-testid="allergen-pills">
      {allergens.map((a) => (
        <span
          key={a}
          className="rounded-full border border-border bg-secondary px-2.5 py-1 text-xs font-medium text-secondary-foreground"
        >
          {allergenName(a, lang)}
        </span>
      ))}
    </div>
  );
}
